<div class="security-page">
   <div class="mfa-security-section">
      <div class="section-header">
         <div class="header-content">
            <h3>{{'new_entries.mfa_authentication' | translate}}</h3>
            <p class="section-description">
               {{'new_entries.enhance_your_account_security_by_enabling_two_factor_authentication' | translate}}</p>
         </div>
         <div class="security-status">
            <div class="status-badge" [ngClass]="{'enabled': mfaEnabled, 'disabled': !mfaEnabled}">
               <i class="fas" [ngClass]="mfaEnabled ? 'fa-shield-alt' : 'fa-shield'"></i>
               <span>{{ mfaEnabled ? ('new_entries.secured' | translate) : ('new_entries.not_secured' | translate)
                  }}</span>
            </div>
         </div>
      </div>

      <div class="mfa-controls">
         <!-- Enable/Disable Toggle -->
         <div class="mfa-toggle-section">
            <div class="toggle-container">
               <label class="toggle-switch">
                  <input type="checkbox" [checked]="mfaEnabled" (change)="toggleMfaStatus($event)">
                  <span class="slider"></span>
               </label>
               <div class="toggle-labels">
                  <span class="toggle-title">{{'new_entries.two_factor_authentication' | translate}}</span>
                  <span class="toggle-subtitle">{{ mfaEnabled ? ('new_entries.your_account_is_protected' | translate) :
                     'new_entries.enable_extra_security_for_your_account' | translate}}</span>
               </div>
            </div>
         </div>

         <!-- Method Selection (only shown when MFA is enabled) -->
         <div *ngIf="mfaEnabled" class="mfa-methods-section">
            <h4>{{'new_entries.authentication_methods' | translate}}</h4>
            <p class="methods-description">{{'new_entries.choose_how_you_want_to_receive_verification_codes' |
               translate}}:</p>

            <div class="methods-grid">
               <div class="method-card" [ngClass]="{'active': emailEnabled}">
                  <div class="method-header">
                     <div class="method-icon email-icon">
                        <i class="fas fa-envelope"></i>
                     </div>
                     <div class="method-info">
                        <h5>{{'new_entries.email_verification' | translate}}</h5>
                        <p>{{'new_entries.get_codes_sent_to_your_email_primary_method' | translate}}</p>
                     </div>
                     <label class="method-toggle-switch">
                        <input type="checkbox" [checked]="emailEnabled" (change)="toggleEmailMfa($event)">
                        <span class="method-slider"></span>
                     </label>
                  </div>
                  <div *ngIf="emailEnabled" class="method-status">
                     <i class="fas fa-check-circle"></i>
                     <span>{{'new_entries.active' | translate}}</span>
                  </div>
               </div>

               <div class="method-card" [ngClass]="{'active': totpEnabled, 'setup-progress': totpSetupInProgress}">
                  <div class="method-header">
                     <div class="method-icon totp-icon">
                        <i class="fas fa-mobile-alt"></i>
                     </div>
                     <div class="method-info">
                        <h5>{{'new_entries.authenticator_app' | translate}}</h5>
                        <p>{{'new_entries.use_google_authenticator_authy_or_similar' | translate}}</p>
                     </div>
                     <label class="method-toggle-switch">
                        <input type="checkbox" [checked]="totpEnabled || totpSetupInProgress"
                           (change)="toggleTotpMfa($event)">
                        <span class="method-slider"></span>
                     </label>
                  </div>
                  <div *ngIf="totpEnabled" class="method-status">
                     <i class="fas fa-check-circle"></i>
                     <span>{{'new_entries.active' | translate}}</span>
                  </div>
                  <div *ngIf="totpSetupInProgress" class="method-status setup-status">
                     <i class="fas fa-clock"></i>
                     <span>{{'new_entries.setup_in_progress_please_verify' | translate}}</span>
                  </div>
               </div>
            </div>
         </div>

         <!-- TOTP Setup Process -->
         <div *ngIf="showQrCode" class="totp-setup-modal">
            <div class="setup-overlay" (click)="cancelTotpSetup()"></div>
            <div class="setup-modal">
               <div class="modal-header">
                  <h4>{{'new_entries.setup_authenticator_app' | translate}}</h4>
                  <button class="close-btn" (click)="cancelTotpSetup()">
                     <i class="fas fa-times"></i>
                  </button>
               </div>
               <div class="modal-content">
                  <div class="setup-steps">
                     <div class="step">
                        <div class="step-number">1</div>
                        <div class="step-content">
                           <h5>{{'new_entries.download_an_authenticator_app' | translate}}</h5>
                           <p>{{'new_entries.we_recommend_google_authenticator_authy_or_microsoft_authenticator' |
                              translate}}</p>
                        </div>
                     </div>
                     <div class="step">
                        <div class="step-number">2</div>
                        <div class="step-content">
                           <h5>{{'new_entries.scan_the_qr_code' | translate}}</h5>
                           <div class="qr-container">
                              <img [src]="qrCodeUrl" alt="QR Code for authenticator app" />
                           </div>
                           <div class="manual-entry">
                              <p>{{'new_entries.cant_scan_enter_this_code_manually' | translate}}:</p>
                              <code class="secret-code">{{ mfaSecret }}</code>
                              <button class="copy-btn" (click)="copySecret()">
                                 <i class="fas fa-copy"></i>
                              </button>
                           </div>
                        </div>
                     </div>
                     <div class="step">
                        <div class="step-number">3</div>
                        <div class="step-content">
                           <h5>{{'new_entries.enter_verification_code' | translate}}</h5>
                           <div class="verification-input">
                              <input type="text" [(ngModel)]="verificationCode" [ngModelOptions]="{standalone: true}"
                                 placeholder="000000" maxlength="6" class="code-input"
                                 (input)="onVerificationCodeInput($event)" />
                              <button class="verify-btn" [disabled]="verificationCode?.length !== 6"
                                 (click)="verifyTotpSetup()">
                                 {{'new_entries.verify_enable' | translate}}
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- Backup Codes Section -->
         <div *ngIf="showBackupCodes" class="backup-codes-section">
            <div class="backup-header">
               <h4>
                  <i class="fas fa-key"></i>
                  {{'new_entries.backup_recovery_codes' | translate}}
               </h4>
               <div class="backup-timer">
                  <i class="fas fa-clock"></i>
                  <span>{{'new_entries.auto_closes_in' | translate}} {{ getCountdownDisplay() }}</span>
               </div>
               <p>{{'new_entries.save_these_codes_in_a_secure_place' | translate}}</p>
            </div>
            <div class="codes-container">
               <div *ngFor="let code of backupCodes" class="backup-code">
                  <span class="code-text">{{ code }}</span>
                  <button class="copy-code-btn" (click)="copyBackupCode(code)">
                     <i class="fas fa-copy"></i>
                  </button>
               </div>
            </div>
            <div class="backup-actions">
               <button class="download-codes-btn" (click)="downloadBackupCodes()">
                  <i class="fas fa-download"></i>
                  {{'new_entries.download_codes' | translate}}
               </button>
               <button class="regenerate-codes-btn" (click)="regenerateBackupCodes()">
                  <i class="fas fa-redo"></i>
                  {{'new_entries.generate_new_codes' | translate}}
               </button>
               <button class="close-backup-btn" (click)="closeBackupCodes()">
                  {{'new_entries.got_it' | translate}}
               </button>
            </div>
         </div>
      </div>
   </div>
</div>